import React, { useState, useEffect } from 'react';
import { client, urlFor } from '../sanityClient';
import SEO from '../components/SEO';
import './Moments.css';

function Moments() {
  const [images, setImages] = useState({
    space: [],
    gatherings: [],
    celebrations: [],
    details: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const query = '*[_type == "moments"] | order(order asc)';
        const data = await client.fetch(query);
        
        const grouped = {
          space: data.filter(item => item.section === 'space'),
          gatherings: data.filter(item => item.section === 'gatherings'),
          celebrations: data.filter(item => item.section === 'celebrations'),
          details: data.filter(item => item.section === 'details')
        };
        
        setImages(grouped);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching images:', error);
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  if (loading) {
    return (
      <div className="moments-page">
        <div className="loading">Loading moments...</div>
      </div>
    );
  }

  const sections = [
    {
      id: 'space',
      title: 'The Space',
      subtitle: 'The garden that started it all',
      images: images.space
    },
    {
      id: 'gatherings',
      title: 'Gatherings',
      subtitle: 'Where people came together',
      images: images.gatherings
    },
    {
      id: 'celebrations',
      title: 'Celebrations',
      subtitle: 'Birthdays, anniversaries, proposals',
      images: images.celebrations
    },
    {
      id: 'details',
      title: 'The Details',
      subtitle: 'The little things that made it special',
      images: images.details
    }
  ];

  return (
    <div className="moments-page">
      <SEO
        title="모먼트 갤러리 | Moments"
        description="가든포에트에서의 특별한 순간들. 실제 웨딩과 행사 갤러리를 통해 당신의 날을 미리 그려보세요."
        path="/moments"
      />
      <section className="moments-hero">
        <div className="container">
          <div className="hero-content fade-in">
            <h1>MOMENTS</h1>
            <p className="hero-subtitle">
              Six years of gatherings at Garden Poète
            </p>
          </div>
        </div>
      </section>

      {sections.map((section) => (
        <section key={section.id} className="moments-section">
          <div className="container">
            <div className="section-header fade-in">
              <h2>{section.title}</h2>
              <p className="section-subtitle">{section.subtitle}</p>
            </div>

            {section.images.length > 0 ? (
              <div className="masonry-grid fade-in">
                {section.images.map((item, index) => (
                  <div 
                    key={item._id} 
                    className={`gallery-item ${index % 5 === 0 ? 'tall' : ''} ${index % 7 === 0 ? 'wide' : ''}`}
                  >
                    <div className="image-wrapper">
                      <img
                        src={urlFor(item.image).width(800).url()}
                        alt={item.caption || section.title}
                        loading="lazy"
                      />
                      {item.caption && (
                        <div className="image-caption">{item.caption}</div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-images">
                <p>No images yet. Add some in Sanity Studio!</p>
              </div>
            )}
          </div>
        </section>
      ))}

      <section className="moments-narrative">
        <div className="container">
          <div className="narrative-content fade-in">
            <p>
              For six years, this garden witnessed thousands of celebrations.
              These moments, captured over time, tell the story of Garden Poète—
              a place where people gathered, laughed, and created memories.
            </p>
            <p>
              Now, as Fairy Garden, we're ready to host the most important
              celebrations of all.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Moments;
